// assets/external-orders.js

const ExternalOrders = (() => {
  const API_BASE = "https://jeans-land-online-shopping.com/public";

  // ─── Read config set by Liquid ───────────────────────────────
  const config = window.ExternalOrdersConfig || {};

  const CUSTOMER_EMAIL = config.customerEmail || "";
  const CUSTOMER_ID   = config.customerId || "";

  const CUSTOMER_TOKEN = btoa(CUSTOMER_EMAIL + ':' + CUSTOMER_ID);

  const headers = {
    'x-customer-token': CUSTOMER_TOKEN,
    "Content-Type": "application/json"
  };

  const euroFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });

  // ─── Helpers ────────────────────────────────────────────────
  function getQueryParam(key) {
    return new URLSearchParams(window.location.search).get(key);
  }

  function formatDate(dateStr) {
    return new Date(dateStr).toLocaleDateString("en-IN", {
      year: "numeric", month: "long", day: "numeric"
    });
  }

  function formatPrice(amount) {
    return euroFormatter.format(amount);
  }

  // ─── Orders List (account page) ─────────────────────────────
  async function renderOrdersList(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    container.innerHTML = `<p class="ext-loading">Loading, please wait...</p>`;

    try {
      const res = await fetch(
        `${API_BASE}/api/customer-sales`,
        { headers }
      );
      if (!res.ok) throw new Error("Failed to fetch orders");

      const data = await res.json();
      const orders = data.orders || data;

      if (!orders.length) {
        container.innerHTML = `<p class="ext-empty">No orders found.</p>`;
        return;
      }

      container.innerHTML = `
        <table class="ext-orders-table orders__table">
          <thead>
            <tr>
                <th>Receipt No.</th>
                <th>Date</th>
                <th>Total Items</th>
                <th>Total Price</th>
                <th>Details</th>
            </tr>
          </thead>
          <tbody>
            ${orders.map(order => `
              <tr>
                <td>${order.receiptNo}</td>
                <td>${new Date(order.saleDateTime).toLocaleDateString()}</td>
                <td>${order.itemCount}</td>
                <td>${formatPrice(order.totalPrice)}</td>
                <td>
                <a href="/pages/purchase-detail?receipt_no=${order.receiptNo}" class="ext-view-btn">
                    View Details →
                </a>
                </td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      `;
    } catch (err) {
      container.innerHTML = `<p class="ext-error">Could not load orders. Please try again later.</p>`;
      console.error("ExternalOrders error:", err);
    }
  }

  // ─── Order Detail (purchase-detail page) ───────────────────────
  async function renderOrderDetail(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const orderId = getQueryParam("receipt_no");
    if (!orderId) {
      container.innerHTML = `<p class="ext-error">No order specified.</p>`;
      return;
    }

    container.innerHTML = `<p class="ext-loading">Loading order details...</p>`;

    try {
      const res = await fetch(`${API_BASE}/api/customer-sales/${orderId}`, { headers });
      if (!res.ok) throw new Error("Order not found");

      const data = await res.json();
      const order = data.order || data;

      container.innerHTML = `
        <div class="ext-order-card">
          <div class="ext-order-header">
            <div>
              <h2>Receipt No #${order.receiptNo}</h2>
              <p class="ext-order-date">Placed on ${formatDate(order.saleDateTime)}</p>
            </div>
          </div>

          <div class="ext-section">
            <h3>Items Ordered (${order.itemCount})</h3>
            <div class="ext-items-list">
              ${(order.line_items || []).map(item => `
                <div class="ext-item">
                  <div class="ext-item-info">
                    <p class="ext-item-title">#${item.receiptPositionNo} ${item.product.articleName || item.product.articleNo}</p>
                    <p class="ext-item-meta">${item.product.brand}</p>
                    ${item.variant ? `<p class="ext-item-meta">SKU: ${item.variant.gtin}, Size: ${item.variant.size}</p>` : ""}
                  </div>
                  <div class="ext-item-price">
                    ${item.discount > 0 ? `<p><del>${formatPrice(item.originalPrice)}</del> ${formatPrice(item.price)}</p>` : formatPrice(item.price)}
                  </div>
                </div>
              `).join("")}
            </div>
          </div>

          <div class="ext-section ext-summary">
            <h3>Order Summary</h3>
            <div class="ext-summary-row"><span>Subtotal:</span><span>${formatPrice(order.subTotal)}</span></div>
            ${order.totalDiscount > 0
              ? `<div class="ext-summary-row ext-discount"><span>Total Discount:</span><span>-${formatPrice(order.totalDiscount)}</span></div>`
              : ""}
            <div class="ext-summary-row ext-total"><span>Total:</span><span>${formatPrice(order.totalPrice)}</span></div>
          </div>
        </div>
      `;
    } catch (err) {
      container.innerHTML = `<p class="ext-error">Could not load order details.</p>`;
      console.error("ExternalOrders error:", err);
    }
  }

  // ─── Public API ──────────────────────────────────────────────
  return { renderOrdersList, renderOrderDetail };
})();